import React from 'react'
import classNames from 'classnames'
import { ExclamationCircleIcon } from '@heroicons/react/24/solid'
import type { UseFormRegisterReturn, FieldErrors } from 'react-hook-form'

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  name: string
  register: UseFormRegisterReturn
  errors: FieldErrors
}

const Textarea = (props: TextareaProps) => {
  const { name, register, errors, className, ...otherProps } = props
  const { disabled } = otherProps

  const classes = classNames(
    'block w-full shadow-xs pr-10 pl-7 sm:text-sm rounded-md',
    {
      'border-cerise-red-300 text-cerise-red-900 placeholder-red-300 focus:outline-hidden focus:ring-cerise-red focus:border-cerise-red': errors[name],
      'focus:ring-perfect-shine focus:border-perfect-shine block w-full border-gray-300': !errors[name],
      'block w-full border-gray-300 bg-gray-50': disabled,
    },
    className,
  )

  return (
    <div className="flex flex-col">
      <div className="relative">
                <textarea
                  {...otherProps}
                  {...register}
                  className={classes}
                />
        {errors[name] && (
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none space-x-1">
            <div className="h-5 w-5">
              {errors[name] && (
                <ExclamationCircleIcon className="text-cerise-red-500" aria-hidden="true"/>
              )}
            </div>
          </div>
        )}
      </div>

      <p className="mt-2 text-sm text-cerise-red-600 select-none min-h-5">
        {(errors?.[name]?.message as string) || ''}
      </p>

    </div>
  )
}

export default Textarea
